import { Fluent9ComponentClassNames } from '../../../../util/classNames';
import { cssVar, makeStyles, mergeClasses } from '../../../../util/styling';

const mainAreaHeroBackground = {
  backgroundImage: '--coreui-appLayout-mainAreaHeroBackground-backgroundImage',
};

interface GetInlineStylesProps {
  readonly imgSrc?: string;
}
export const getInlineStyles = ({ imgSrc }: GetInlineStylesProps) => ({
  [mainAreaHeroBackground.backgroundImage]: `url(${imgSrc})`,
});

interface UseClassNamesProps {
  readonly isWide: boolean;
}
type UseClassNames = ({ isWide }: UseClassNamesProps) => Fluent9ComponentClassNames<'mainAreaHeroBackground'>;
export const useClassNames: UseClassNames = ({ isWide }) => {
  const mainAreaHeroBackgroundClasses = useMainAreaHeroBackgroundClasses();

  return {
    mainAreaHeroBackground: mergeClasses(
      mainAreaHeroBackgroundClasses.mainAreaHeroBackground,
      isWide && mainAreaHeroBackgroundClasses.mainAreaHeroBackgroundWide
    ),
  };
};

const useMainAreaHeroBackgroundClasses = makeStyles({
  mainAreaHeroBackground: {
    backgroundImage: 'none',
  },
  mainAreaHeroBackgroundWide: {
    backgroundImage: `${cssVar(mainAreaHeroBackground.backgroundImage)}`,
    backgroundPositionX: 0,
    backgroundPositionY: 0,
    backgroundSize: '100% auto',
    backgroundRepeat: 'no-repeat',
    width: '100%',
    height: '100%',
  },
});
